<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
/* fix 表格表头不对齐 */
.el-table th.gutter{
    display: table-cell!important;
}



.el-calendar-table .el-calendar-day {
  padding: 0 !important;
}

.el-calendar-table .el-calendar-day:hover {
    background: transparent !important;
}

.el-calendar-table td.is-selected {
  background-color: transparent !important;
}
</style>




// WEBPACK FOOTER //
// src/App.vue